import axiosInstance from "./AxiosInstance";

export const LoginApi = async ({ email, password }) => {
    const response = await axiosInstance.post('/auth/login', { email, password });
    return response;
}

export const SignUpApi = async (form) => {
    console.log(form)
    const response = await axiosInstance.post('/auth/signup', form);
    return response;
}

export const GetUsersApi = async () => {
    const response = await axiosInstance.get('/users');
    return response;
}

export const MyAccounts = async () => {
    const response = await axiosInstance.get('/my-account');
    if(response.status === 200){
        return response.data.data;
    }
    throw new Error("Unable to fetch account");
}
export const MyDashboard = async () => {
    const response = await axiosInstance.get('/dashboard');
    if(response.status === 200){
        return response.data.data;
    }
    throw new Error("Unable to fetch account");
}


export const MyVendorsProfile = async (id) => {
    const response = await axiosInstance.get('/id');
    if(response.status == 200){
        return response.data.data;
    }else{
        console.log("------------------>> I Am Called")
        // throw new Error("Error");
    }
}

export const CreateCategories = async (formData) =>{
        return axiosInstance.post("/categories",
             {body:formData}, 
        {
        headers: {
            "Content-Type": "multipart/form-data",
        },
  });
}

export const ProductColorAdded = async (data) =>{
        return axiosInstance.post("/products/color",data);
}

export const AddProductHome = async (data) =>{
        return axiosInstance.post("/homeapp",data);
}

export const ProductSizeAdded = async (data) =>{
        return axiosInstance.post("/products/size",data);
}

export const ProductColorList = async (id) =>{
        return axiosInstance.get(`/products/color/${id}`);
}

export const GetCategories = async () =>{
    return axiosInstance.get("/categories"); 
}

export const GetOperationsBrand = async () =>{
    return axiosInstance.get("/brands"); 
}

export const GetAllListBrands = async () =>{
    return axiosInstance.get("/brands/all"); 
}

export const GetPendingBrandRequests = async () => {
    return axiosInstance.get("/brands/approval-requests");
}

export const ReviewBrandRequest = async (id, approvalStatus) => {
    return axiosInstance.patch(`/brands/approval-requests/${id}`, { approvalStatus });
}

export const GetHomeAppScreenList = async (id) =>{
    return axiosInstance.get(`/homeapp/${id}`); 
}
export const updateSectionSorting = async (data) => {
    return axiosInstance.put(`/homeapp/update-sorting`,data);
}

export const DeleteHomeAppScreenList = async (id) =>{
    return axiosInstance.delete(`/homeapp/${id}`); 
}

export const DeleteCategory = async (id) =>{
    return axiosInstance.delete(`/categories/${id}`);
}


export const GetBrands = async (id) =>{
    return axiosInstance.get(`/brands/${id}`);
}

export const GetSubCategories = async (id) =>{
    return axiosInstance.get(`/subcategories/${id}`); 
}

export const DeleteSubCategory = async (id) =>{
    return axiosInstance.delete(`/subcategories/${id}`);
}

export const UpdateSubCategoryStatus = async (id,data) => {
    return axiosInstance.post(`/subcategories/${id}/status`,data);
}
export const GetSubSubCategories = async (subId,catId) =>{
    return axiosInstance.get(`/subsubcategories/${subId}/${catId}`);
}

export const GetSubSubCategoriesByCategoryId = async (catId) =>{
    return axiosInstance.get(`/subsubcategories/${catId}`);
}

export const DeleteSubSubCategory = async (id) =>{
    return axiosInstance.delete(`/subsubcategories/${id}`);
}

export const UpdateSubSubCategoryStatus = async (id,data) => {
    return axiosInstance.post(`/subsubcategories/${id}/status`,data);
}

export const GetProducsByAdmin = async (adminId, page = 1, limit = 10) =>{
    return axiosInstance.get(`/products/admin/${adminId}`, { params: { page, limit } });
}

export const GetDraftProducts = async (adminId, page = 1, limit = 10) =>{
    return axiosInstance.get(`/products/drafts/${adminId}`, { params: { page, limit } });
}

export const DeleteProducts = async (id) =>{
    return axiosInstance.delete(`/products/${id}`);
}

export const viewProductsApi = async (id) =>{
    return axiosInstance.get(`/products/${id}`);
}

export const GetBanners = async () =>{
    return axiosInstance.get("/banners"); 
}

export const UpdateBannersStatus = async (id,data) => {
    return axiosInstance.post(`/banners/${id}/status`,data);
}

export const DeleteBanners = async (id) =>{
    return axiosInstance.delete(`/banners/${id}`);
}

export const UpdateUserApi = async (id,obj) =>{
    console.log(id,obj)
    // return axiosInstance.put("/editUser",${id}); 
}

export const CreateVendor = async (form) => {
    const response = await axiosInstance.post('/vendor', form);
    return response;
}
export const UpdateVendor = async (formData) => {
    const response = await axiosInstance.post('/vendor/update', formData);
    return response;
}

export const GetVendorListAPI = async () => {
    const response = await axiosInstance.get('/vendor');
    return response;
}

export const GetVendorProfiles = async (id) =>{
    return axiosInstance.get(`/vendor/${id}`); 
}

export const UpdateVendorProfile = (id,data) => {
    return axiosInstance.post(`/vendor/account_status/${id}`,data);
}

export const ApproveVendorProfile = (id,data) => {
    return axiosInstance.post(`/vendor/approve/${id}`,data);
}

export const SendVendorCredentials = (id) => {
    return axiosInstance.post(`/vendor/send-credentials/${id}`);
}

export const GetUnverificationsProducts = async (id,unverify_products, page = 1, limit = 10) =>{
    return axiosInstance.get(`/products/unverify_products/${id}/${unverify_products}`, { params: { page, limit } });
}

export const GetCategoryBrandsList = async (brandsId,category,subcategory,adminId) =>{
    return axiosInstance.get(`/products/category-brand-list/${brandsId}/${category}/${subcategory}/${adminId}`);
}

export const GetVerifyStatusOfProduct = async (data) =>{
    return axiosInstance.post(`/products/verify-products-status`,data);
}

export const ProductStatusUpdate = async (id,data) => {
    return axiosInstance.post(`/products/${id}`,data);
}

export const GetProductByIdApi = async (id) => {
    return axiosInstance.get(`/products/${id}`);
}
export const GetProductByCategoryID = async (id) => {
    return axiosInstance.get(`/products/category/${id}`);
}

export const UpdateProductApi = async (id,data) => {
    return axiosInstance.put(`/products/update/${id}`,data);
}

export const UpdateUserPassword = async (data) => {
    return axiosInstance.post(`/auth/update/password`,data);
}

export const SaveSettings = async (data) => {
  return axiosInstance.post("/settings", data);
};

export const GetSettings = async () => {
  return axiosInstance.get("/settings");
};

export const UpdateCategoryStatus = async (id,data) => {
    return axiosInstance.post(`/categories/${id}/status`,data);
}

export const UpdateProductStatus = async (id,data) => {
    return axiosInstance.post(`/products/${id}/status`,data);
}

export const UsersList = async (page = 1, limit = 10) => {
    return axiosInstance.get(`/users/list`, { params: { page, limit } });
}
export const GetVendorsOrders = async (id, page = 1, limit = 10) => {
    return axiosInstance.get(`/orders/vendor-orders/${id}`, { params: { page, limit } });
}
export const GetOrders = async (page = 1, limit = 10) => {
    return axiosInstance.get(`/orders`, { params: { page, limit } });
}
export const GetOrdersByIdApi = async (id) => {
    return axiosInstance.get(`/orders/${id}`);
}

export const GetOrdersVendorByIdApi = async (id) => {
    return axiosInstance.get(`/orders/vendor-view/${id}`);
}

export const UpdateOrderStatus = async (id,data) => {
    return axiosInstance.post(`/orders/status-timeline/${id}`,data);
}

export const GetVendorKPIs = async (vendorId, startDate, endDate, groupBy) => {
    return axiosInstance.get(`/analytics/vendor-kpis`, { params: { vendorId, startDate, endDate, groupBy } });
}

export const GetVendorProductAnalytics = async (vendorId, startDate, endDate, page = 1, limit = 10) => {
    return axiosInstance.get(`/analytics/vendor-products`, { params: { vendorId, startDate, endDate, page, limit } });
}

export const GetVendorOrderAnalytics = async (vendorId, startDate, endDate, page = 1, limit = 10) => {
    return axiosInstance.get(`/analytics/vendor-orders`, { params: { vendorId, startDate, endDate, page, limit } });
}

export const GetCoupons = async () => {
    return axiosInstance.get("/coupons");
}

export const CreateCoupon = async (data) => {
    return axiosInstance.post("/coupons", data);
}

export const DeleteCoupon = async (couponCode) => {
    return axiosInstance.delete(`/coupons/${encodeURIComponent(couponCode)}`);
}

export const UpdateCouponStatus = async (couponCode, status) => {
    return axiosInstance.post(`/coupons/${encodeURIComponent(couponCode)}/status`, { status });
}
